
import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import HealthTableUsers from './HealthTableUsers';
import { myUser } from '../../helpers/satiBack';

const HealthTable = () => {
  const [user, setUser] = useState({});

  useEffect(() => {
    myUser()
      .then(data => {
        setUser(data); 
        //console.log('userDate:',data)
      })
      .catch(err => console.error(err))     // TODO: Error handling
  }, []);

  const role = Number(sessionStorage.getItem('satiRol'));

  switch (role) {
    case 2: return <HealthTableUsers user={user}/>
    default: return <Redirect to="/login"/>;
  }

}

export default HealthTable;
